import { Navigate } from 'react-router';
import { useHasPermission } from '@/features/access-control';
import { ADDON_BUY_PERMISSIONS } from '@/features/marketplace/addons';
import { Skeleton } from '@/shared/ui/skeleton';

const ADDON_BUY_PERMISSION_LIST = Array.from(ADDON_BUY_PERMISSIONS);

/** Redirects the marketplace index route to `addons` when the user can buy addons, or `devices` otherwise. */
const MarketplaceGuard = () => {
	const { hasPermission: canAccessAddons, isLoading } = useHasPermission(
		ADDON_BUY_PERMISSION_LIST,
		'any',
	);

	if (isLoading)
		return (
			<div className='flex flex-col gap-4 p-6 w-full'>
				<Skeleton
					height={28}
					width='35%'
					borderRadius={8}
				/>
				<Skeleton
					height={16}
					count={2}
					borderRadius={6}
				/>
				<Skeleton
					height={180}
					borderRadius={12}
				/>
			</div>
		);

	return (
		<Navigate
			to={canAccessAddons ? 'addons' : 'devices'}
			replace
		/>
	);
};

export default MarketplaceGuard;
